import React from "react";
import { useSelector } from "react-redux";
import FunnelGraph from "../../../../components/funnelGraph/funnelGraph";

export const LaserFunnelGraph = () => {
  let {
    labels,
    averageValues,
    values,
    rawDataValues,
    subPercents,
    subLabelsLinks = [],
    percentLabels
  } = useSelector((state) => state.laser.funnelChartData.chart);

  const startFrom = useSelector((state) => state.laser.selectedFilters.startFrom);
  const showGraphWithoutValues = useSelector((state) => state.laser.showGraphWithoutValues);
  const averageTooltip = useSelector((state) => state.laser.averageTooltip);

  const isStartFromEnrollment = startFrom == "enrollments";

  return (
    <FunnelGraph
      id="funnelLaserChart"
      colors={
        isStartFromEnrollment
          ? ["#0099ce", "#42b77a", "#ff664e", "#5873fd", "#ffc74e"]
          : [
              ["#0099ce", "#005a79"],
              ["#42b77a", "#20583b"],
              ["#ff664e", "#6d2e24"],
              ["#5873fd", "#28326b"],
              ["#ffc74e", "#ffc74e42"]
            ]
      }
      direction={isStartFromEnrollment ? "vertical" : "horizontal"}
      gradientDirection="vertical"
      labels={labels}
      averageValues={averageValues}
      averageTooltip={averageTooltip}
      hideSubLabels
      subLabelVisibility={[false, true, true, true]}
      width={1350}
      height={450}
      values={values}
      rawDataValues={rawDataValues}
      subPercents={subPercents}
      subLabels={["", ...subLabelsLinks.map((elem) => elem.label)]}
      breakdownRawData={["", ...subLabelsLinks.map((elem) => elem.link)]}
      showGraphWithoutValues={showGraphWithoutValues}
      percentLabels={percentLabels} //[["Lead to Appointment"], ["Lead to Show", "Appointment to Show"], ["Lead to Enrollment", "Show to Enrollment"]]
      container="funnelV2"
    />
  );
};
